import { FC, ReactNode } from "react";
import PageSection from "@app/shared/PageSection";

export interface MultiMapExportSectionProps {
  children?: ReactNode;
  className?: string;
  sectionNumber: number;
  subHeader: string;
  testId?: string;
  title: string;
}

export const MultiMapExportSection: FC<MultiMapExportSectionProps> = ({
  children,
  className,
  sectionNumber,
  subHeader,
  testId,
  title,
}: MultiMapExportSectionProps) => (
  <PageSection className={className}>
    <section className="multi-map-export__section" data-testid={testId}>
      <div className="multi-map-export__section-header">
        <h2 className="multi-map-export__section-title">{`${sectionNumber}. ${title}`}</h2>
        <p className="multi-map-export__section-sub-header">{subHeader}</p>
      </div>
      <div className="multi-map-export__section-body">
        {children}
      </div>
    </section>
  </PageSection>
);

export default MultiMapExportSection;
